import { CIC_SAVE_NOTE_MAX_LENGTH } from 'constants/cicReason';

export const getNoteError = note => {
  const trimmed = note.trim();

  if (!trimmed) {
    return 'Note is required';
  }

  if (trimmed.length > CIC_SAVE_NOTE_MAX_LENGTH) {
    return `Note must be ${CIC_SAVE_NOTE_MAX_LENGTH} characters or fewer`;
  }

  return '';
};
